import { RouteSummary } from 'src/app/core/models/operations';

export const CONSTS = {
  PENDING: $localize`Pending`.toUpperCase(),
  SUMMARY: $localize`Summary`.toUpperCase(),
  TABLE_PENDING: $localize`Table for Pending`,
  HEADER: $localize`Operations`,
  SUBHEADER: $localize`Route Summary`,
  UPLOAD: $localize`Upload`,
};

export const MOCK_SUMMARY_DATA: RouteSummary[] = [
  {
    route: '123',
    deliveryStops: {
      total: 10,
      completed: 7,
      pending: 3,
    },
    deliveryVolume: {
      total: 15,
      completed: 10,
      pending: 5,
    },
    pickupStops: {
      total: 10,
      completed: 7,
      pending: 3,
    },
    pickupVolume: {
      completed: 10,
    },
    routeCompletionStatus: {
      stops: 98,
      volume: 70,
    },
  },
  {
    route: '456',
    deliveryStops: {
      total: 15,
      completed: 10,
      pending: 5,
    },
    deliveryVolume: {
      total: 10,
      completed: 10,
      pending: 0,
    },
    pickupStops: {
      total: 12,
      completed: 6,
      pending: 6,
    },
    pickupVolume: {
      completed: 14,
    },
    routeCompletionStatus: {
      stops: 42,
      volume: 23,
    },
  },
  {
    route: '789',
    deliveryStops: {
      total: 12,
      completed: 4,
      pending: 8,
    },
    deliveryVolume: {
      total: 41,
      completed: 30,
      pending: 11,
    },
    pickupStops: {
      total: 63,
      completed: 50,
      pending: 13,
    },
    pickupVolume: {
      completed: 60,
    },
    routeCompletionStatus: {
      stops: 65,
      volume: 13,
    },
  },
  {
    route: '012',
    deliveryStops: {
      total: 50,
      completed: 47,
      pending: 3,
    },
    deliveryVolume: {
      total: 19,
      completed: 9,
      pending: 10,
    },
    pickupStops: {
      total: 50,
      completed: 27,
      pending: 23,
    },
    pickupVolume: {
      completed: 7,
    },
    routeCompletionStatus: {
      stops: 100,
      volume: 100,
    },
  },
  {
    route: '345',
    deliveryStops: {
      total: 20,
      completed: 7,
      pending: 13,
    },
    deliveryVolume: {
      total: 35,
      completed: 16,
      pending: 19,
    },
    pickupStops: {
      total: 5,
      completed: 1,
      pending: 4,
    },
    pickupVolume: {
      completed: 10,
    },
    routeCompletionStatus: {
      stops: 20,
      volume: 20,
    },
  },
  {
    route: '678',
    deliveryStops: {
      total: 14,
      completed: 7,
      pending: 7,
    },
    deliveryVolume: {
      total: 43,
      completed: 4,
      pending: 40,
    },
    pickupStops: {
      total: 12,
      completed: 11,
      pending: 1,
    },
    pickupVolume: {
      completed: 30,
    },
    routeCompletionStatus: {
      stops: 90,
      volume: 90,
    },
  },
];

export const MOCK_ROUTE_SUMMARY_RESPONSE = {
  response: {
    routesummary: MOCK_SUMMARY_DATA,
  },
};
